import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useWorkspacesList } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";

interface Props {
    filters: FiltersTypes;
}

export const ScheduleClientFilterLabel: React.FC<Props> = ({ filters }) => {
    const { organizationId } = useScope();
    const { data: clients = [] } = useWorkspacesList(
        organizationId ? { organizationId } : undefined,
        { enabled: !!organizationId },
    );
    const { scheduleClientIds } = filters;

    const selectedNames = useMemo(
        () =>
            clients
                .filter((c) => scheduleClientIds?.includes(c.id))
                .map((c) => c.name),
        [clients, scheduleClientIds],
    );

    if (selectedNames.length === 0) {
        return null;
    }

    if (selectedNames.length === 1) {
        return <span>{selectedNames[0]}</span>;
    }

    return <span>{selectedNames.length} clients</span>;
};
